import pme from "../models/pme";

export const types = {
  ADDITIONAL_INFORMATION_REQUESTED_PME: "ADDITIONAL_INFORMATION_REQUESTED_PME",
  ADDITIONAL_INFORMATION_SUCCEDDED_PME: "ADDITIONAL_INFORMATION_SUCCEDDED_PME",
  ADDITIONAL_INFORMATION_FAILED_PME: "ADDITIONAL_INFORMATION_FAILED_PME",
  TOGGLE_TOAST_PME: "TOGGLE_TOAST_PME",
  GET_SITES_REQUESTED: "GET_SITES_REQUESTED",
  GET_SITES_SUCCEDDED: "GET_SITES_SUCCEDDED",
  GET_SITES_FAILED: "GET_SITES_FAILED",
  NEW_SITE: "NEW_SITE_PME",
  NEW_SITE_SUCCEDDED: "NEW_SITE_SUCCEDDED",
  NEW_SITE_FAILED: "NEW_SITE_FAILED_PME",
  GET_STAKEHOLDERS_REQUESTED: "GET_STAKEHOLDERS_REQUESTED",
  GET_STAKEHOLDERS_SUCCEDDED: "GET_STAKEHOLDERS_SUCCEDDED",
  GET_STAKEHOLDERS_FAILED: "GET_STAKEHOLDERS_FAILED",
  NEW_STAKEHOLDER: "NEW_STAKEHOLDER",
  NEW_STAKEHOLDER_SUCCEDDED: "NEW_STAKEHOLDER_SUCCEDDED",
  NEW_STAKEHOLDER_FAILED: "NEW_STAKEHOLDER_FAILED"
};

export const actions = {
  submitAdditionalInformationPME: (payload) => {
    return { type: types.ADDITIONAL_INFORMATION_REQUESTED_PME, value: payload };
  },
  setSubmittedPME: (payload) => {
    return { type: types.TOGGLE_TOAST_PME, value: payload };
  },
  setErrorsPME: (payload) => {
    return { type: types.ADDITIONAL_INFORMATION_FAILED_PME, value: payload };
  },
  getSites: () => {
    return { type: types.GET_SITES_REQUESTED }
  },
  submitNewSite: payload => {
    return { type: types.NEW_SITE, value: payload };
  },
  getStakeholders: () => {
    return { type: types.GET_STAKEHOLDERS_REQUESTED };
  },
  submitNewStakeholder: payload => {
    return { type: types.NEW_STAKEHOLDER, value: payload };
  }
};

const reducer = (state = pme, action) => {
  switch (action.type) {
    case types.ADDITIONAL_INFORMATION_REQUESTED_PME:
      return {
        ...state,
        submiting: true,
      };

    case types.ADDITIONAL_INFORMATION_SUCCEDDED_PME:
      return {
        ...state,
        submiting: false,
        submitted: true,
      };
    case types.TOGGLE_TOAST:
      return {
        ...state,
        submitted: action.value || false,
      };
    case types.ADDITIONAL_INFORMATION_FAILED_PME:
      return {
        ...state,
        submiting: false,
        submitted: false,
        errors: action.value || null,
      };
    case types.GET_SITES_SUCCEDDED:
      return {
        ...state,
        sites: action.value.map(site => Object.assign(site, { collapse: true }))
      }
    case types.NEW_SITE_SUCCEDDED:
      return {
        ...state,
        submitted: true,
        sites: action.value.map(site => Object.assign(site, { collapse: true }))
      }
    case types.NEW_SITE_FAILED:
      return {
        ...state,
        submiting: false,
        submitted: false,
        errors: action.value || null
      }
    case types.GET_STAKEHOLDERS_SUCCEDDED:
      return {
        ...state,
        stakeholders: action.value.map(stakeholder => Object.assign(stakeholder, { collapse: true }))
      }
    case types.NEW_STAKEHOLDER_SUCCEDDED:
      return {
        ...state,
        submitted: true,
        stakeholders: action.value.map(stakeholder => Object.assign(stakeholder, { collapse: true }))
      }
    case types.NEW_STAKEHOLDER_FAILED:
      return {
        ...state,
        submiting: false,
        submitted: false,
        errors: action.value || null
      }

    default:
      return state;
  }
};

export default reducer;
